import React from 'react';
import PropTypes from 'prop-types';
import { pageContext } from 'ctm-util-functions';
import { useStyles } from './mecha_input_field_styles';
import { LoadingAnimation } from '../../loading_animation/loading_animation';

const MechaInputField = (props) => {
    const { handleChange, inputId, type, maxlength, pattern, placeholder, required, disabled, loading, invalid, onEnter, value, dataId } = props;

    // Create an error state (for styling) that doesn't stem from 'required=true' and form validation.
    const errorState = invalid;
    const isXs = pageContext.getProps().pageState.breakpoint === 'xs';
    const classes = useStyles({ isXs, errorState });

    return (
        <div
            className={classes.input_field_wrapper}
            data-id={dataId}
        >
            <input
                className={classes.mecha_input_field}
                value={value}
                type={type}
                id={inputId}
                name={inputId}
                maxLength={maxlength}
                pattern={pattern}
                placeholder={placeholder}
                required={required}
                disabled={disabled}
                onKeyDown={ (event) => {
                    if (event.key === 'Enter') {
                        onEnter(event);
                    }
                }}
                onChange={ (event) => { handleChange(event.target.value); }}
            />
            {
                loading
                    ? (
                        <span className={classes.input_field_span}>
                            <LoadingAnimation />
                        </span>
                    )
                    : null
            }
        </div>
    );
};

MechaInputField.propTypes = {
    handleChange: PropTypes.func,
    onEnter: PropTypes.func,
    value: PropTypes.string,
    dataId: PropTypes.string,
    inputId: PropTypes.string,
    type: PropTypes.string,
    maxlength: PropTypes.number,
    pattern: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    loading: PropTypes.bool,
    invalid: PropTypes.bool
};

export { MechaInputField };
